/**
* Throttler is an manager for throttling and debouncing Events
* so we can ensure that only a single callback(i.e. fn) Event type 
* is triggered for each DOM element given a specific time window(i.e. delay) 
*/
class Throttler {
    constructor() {
        this.stack = [];
        //console.log('[Throttler] Constructed');
    }

    throttleAndDebounce(ev, fn, delay) {
        //console.log('[Throttler] Stacking event', ev.target);
        let stackedEvent = this.stack.find(x => x.target === ev.target);

        if (stackedEvent) {
            //console.log('[Throttler] Found stacked event', stackedEvent);
            clearTimeout(stackedEvent.timerId);
            this.remove(ev.target);
        }

        //console.log('[Throttler] Stacking new event', ev.target);
        this.stack.push({
            target: ev.target,
            timerId: setTimeout(() => {
                //console.log('[Throttler] Triggering timeout', ev.target);
                fn(ev);
                this.remove(ev.target);
            }, delay)
        });
    }

    remove(target) {
        //console.log('[Throttler] Removing event from stack', target);
        this.stack = this.stack.filter(x => x.target === target);
    }
}

export default Throttler;


// WEBPACK FOOTER //
// ./_static/js/throttler.js